import { Moment } from 'moment-timezone'
import React from 'react'
import styled from 'styled-components'

import { color } from 'styles/colors'

import CollapsiblePanel from 'components/CollapsiblePanel'

import Details from 'pages/shared/Alert/Details'
import AlertHeader from 'pages/shared/AlertsHistory/AlertHeader'

import { screenSize } from 'styles/shared'

import { alertCodeDisplayValue, isSerialIdValid, isUnitTypeValid } from 'helpers/alerts'

import { Alert } from 'types/Alert'

type AlertHeaderType = 'ActiveAlert' | 'AlertHistory'

interface ActiveAlert extends Omit<Alert, 'zoneId'> {
  zoneId?: string | number | null,
}

type Props = {
  alerts: Array<ActiveAlert>
  headerType?: AlertHeaderType
  showDayRthCallback?: (day: Moment) => void
  className?: string
}

const AlertList = ({ alerts, showDayRthCallback, headerType = 'ActiveAlert', className }: Props) => {
  return (
    <S.AlertList className={className}>
      { alerts.map((alert, index) => {
        const { problems, possibleCauses, additionalInfo, code, unitType = null, serialId = null, zoneName, zoneId, id = '', clearedBy } = alert
        const hasZoneInfo = zoneId !== null && zoneId !== 0
        const alertNumber = index + 1

        return (
          <S.AlertItem key={`${id}-${alertNumber}-${clearedBy}`}>
            <AlertHeader alert={alert} headerType={headerType} showDayRthCallback={showDayRthCallback} alertNumber={alertNumber} />
            <S.HeaderDetail>{alertCodeDisplayValue(code)}</S.HeaderDetail>
            {isUnitTypeValid(unitType, serialId) && <S.HeaderDetail>{unitType}</S.HeaderDetail>}
            {isSerialIdValid(serialId) && <S.HeaderDetail>{serialId}</S.HeaderDetail>}
            {hasZoneInfo && <S.HeaderDetail>Zone ID: {zoneId} - {zoneName}</S.HeaderDetail>}
            <S.DetailsContainer headerType={headerType}>
              <S.Details {...{ problems, possibleCauses, additionalInfo }} />
            </S.DetailsContainer>
          </S.AlertItem>
        )
      })}
    </S.AlertList>
  )
}

export default AlertList

const S = {
  AlertList: styled.div`
      width: 100%;
  `,
  AlertItem: styled.div`
    border-bottom: 0.6px solid ${color('serviceContractNone')};
    margin-bottom: 25px;
    @media ${screenSize.small} {
      padding-left: 0;
    }
  `,
  CollapsiblePanel: styled(CollapsiblePanel)`
    & > div:first-of-type {
      & > i {
        display: none;
      }
    }
  `,
  HeaderDetail: styled.div`
    color: ${color('secondaryText')};
    margin-left: 30px;
  `,
  DetailsContainer: styled.div.withConfig({
    shouldForwardProp: (prop) => !['headerType'].includes(prop)
  })<{ headerType: AlertHeaderType }>`
    padding: 25px 0;
    @media ${screenSize.small} {
      padding: 10px 0;
    }
  `,
  Details: styled(Details)`
    > h4{
      text-transform: capitalize;
      margin: 0 0 8px 0;
    }
    > ul{
      padding-bottom: 24px;
      &:last-child{
        padding-bottom: 0;
      }
    }
  `
}
